import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
//import { post } from 'jquery';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';

declare var google;
@Component({
  selector: 'adfprimaryform',
  templateUrl: 'primary.html',
  providers: [EnvDataService]
})
export class PrimaryForm {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();
  @Output() valueChangeSecond = new EventEmitter();
  @ViewChild('primaryFormElement') primaryFormElement: ElementRef;
  callMethod() {
    alert('successfully executed.')
    console.log('successfully executed.');
    //this.test++;
  }

  primaryForm: FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public change_log_string: any;
  public address_format;

  public validation_messages = {
    'firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],
    'reference_broker': [
      { type: 'required', message: 'Broker is required.' }
    ],

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public el: ElementRef,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      console.log(data);
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];

    this.primaryForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(12), Validators.maxLength(12), Validators.required])],
      date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      reference_broker: [''],
      user_document_id: [''],
    });


  }
  ngOnInit() {
  }


  ngOnChanges() {
    console.log('abc', this.editdata); // object here
    this.primaryForm.controls.reference_broker.setValue(this.editdata.user_data.reference_broker);
    this.primaryForm.controls.firstname.setValue(this.editdata.user_data.firstname == 0 ? "" : this.editdata.user_data.firstname);
    this.primaryForm.controls.middlename.setValue(this.editdata.user_data.middlename == 0 ? "" : this.editdata.user_data.middlename);
    this.primaryForm.controls.lastname.setValue(this.editdata.user_data.lastname == 0 ? "" : this.editdata.user_data.lastname);
    this.primaryForm.controls.email.setValue(this.editdata.user_data.email == 0 ? "" : this.editdata.user_data.email);
    this.primaryForm.controls.mobile_phone.setValue(this.editdata.user_data.mobile_phone == 0 ? "" : this.editdata.user_data.mobile_phone);
    this.primaryForm.controls.date_of_birth.setValue(this.editdata.user_data.date_of_birth);

  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }
  get formApplicant() {
    return this.primaryForm.get('addAnotherApplicantItem') as FormArray;
  }



  changeLog(event, index: any) {
    // let this = this;
    // var property = event.ngControl.name;
    // this.new_val = event._value;
    // this.old_val = '';
    // var new_property = '';

    // if(index == 'main'){
    //   if(property == 'firstname'){
    //     this.old_val = (this.applicant_details.firstname == undefined) ? '' : this.applicant_details.firstname;
    //     new_property = 'Firstname';
    //     this.firstname = this.new_val;
    //   }
    //   if(property == 'middlename'){
    //     this.old_val = (this.applicant_details.middlename == undefined) ? '' : this.applicant_details.middlename;
    //     new_property = 'Middlename';
    //   }
    //   if(property == 'lastname'){
    //     this.old_val = (this.applicant_details.lastname == undefined) ? '' : this.applicant_details.lastname;
    //     new_property = 'Lastname';
    //     this.lastname = this.new_val;
    //   }
    //   if(property == 'email'){
    //     this.old_val = (this.applicant_details.email == undefined) ? '' : this.applicant_details.email;
    //     new_property = 'Email';
    //     this.checkContact = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkContact = 0;
    //         }else{
    //           this.checkContact = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }
    //   if(property == 'mobile_phone'){
    //     this.old_val = (this.applicant_details.mobile_phone == undefined) ? '' : this.applicant_details.mobile_phone;
    //     new_property = 'Mobile Phone';
    //   }
    //   if(property == 'primayr_goal_intention'){
    //     this.old_val = (this.applicant_details.primayr_goal_intention == undefined) ? '' : this.applicant_details.primayr_goal_intention;
    //     new_property = 'Primary Goal Intention';
    //   }
    //   if(property == 'floor_number'){
    //     this.old_val = (this.applicant_details.floor_number == undefined) ? '' : this.applicant_details.floor_number;
    //     new_property = 'Floor Number';
    //   }
    //   if(property == 'unit_number'){
    //     this.old_val = (this.applicant_details.unit_number == undefined) ? '' : this.applicant_details.unit_number;
    //     new_property = 'Unit Number';
    //   }
    //   if(property == 'building_name'){
    //     this.old_val = (this.applicant_details.building_name == undefined) ? '' : this.applicant_details.building_name;
    //     new_property = 'Building Name';
    //   }
    //   if(property == 'street_number'){
    //     this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
    //     new_property = 'Street Number';
    //   }
    //   if(property == 'street_name'){
    //     this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
    //     new_property = 'Street Name';
    //   }
    //   if(property == 'city'){
    //     this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
    //     new_property = 'City';
    //   }
    //   if(property == 'postcode'){
    //     this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
    //     new_property = 'Postcode';
    //   }
    //   if(property == 'poboxlabel'){
    //     this.old_val = (this.applicant_details.poboxlabel == undefined) ? '' : this.applicant_details.poboxlabel;
    //     new_property = 'PO Box Label';
    //   }
    //   if(property == 'first_child_age'){
    //     this.old_val = (this.applicant_details.first_child_age == undefined) ? '' : this.applicant_details.first_child_age;
    //     new_property = 'First Child Age';
    //   }
    //   if(property == 'second_child_age'){
    //     this.old_val = (this.applicant_details.second_child_age == undefined) ? '' : this.applicant_details.second_child_age;
    //     new_property = 'Second Child Age';
    //   }
    //   if(property == 'third_child_age'){
    //     this.old_val = (this.applicant_details.third_child_age == undefined) ? '' : this.applicant_details.third_child_age;
    //     new_property = 'Third Child Age';
    //   }
    //   if(property == 'fourth_child_age'){
    //     this.old_val = (this.applicant_details.fourth_child_age == undefined) ? '' : this.applicant_details.fourth_child_age;
    //     new_property = 'Fourth Child Age';
    //   }
    //   if(property == 'fifth_child_age'){
    //     this.old_val = (this.applicant_details.fifth_child_age == undefined) ? '' : this.applicant_details.fifth_child_age;
    //     new_property = 'Fifth Child Age';
    //   }
    //   if(property == 'sixth_child_age'){
    //     this.old_val = (this.applicant_details.sixth_child_age == undefined) ? '' : this.applicant_details.sixth_child_age;
    //     new_property = 'Sixth Child Age';
    //   }
    //   if(property == 'your_occupation'){
    //     this.old_val = (this.employment_details.your_occupation == undefined) ? '' : this.employment_details.your_occupation;
    //     new_property = 'Your Occupation';
    //   }
    //   if(property == 'start_date'){
    //     this.old_val = (this.employment_details.start_date == undefined) ? '' : this.employment_details.start_date;
    //     new_property = 'Employment start date';
    //   }
    //   if(property == 'business_name'){
    //     this.old_val = (this.employment_details.business_name == undefined) ? '' : this.employment_details.business_name;
    //     new_property = 'Business Name';
    //   }
    //   if(property == 'type_of_entity'){
    //     this.old_val = (this.employment_details.type_of_entity == undefined) ? '' : this.employment_details.type_of_entity;
    //     new_property = 'Type of Entity';
    //   }
    //   if(property == 'abn_acn'){
    //     this.old_val = (this.employment_details.abn_acn == undefined) ? '' : this.employment_details.abn_acn;
    //     new_property = 'abn_acn';
    //   }
    //   if(property == 'nature_of_business'){
    //     this.old_val = (this.employment_details.nature_of_business == undefined) ? '' : this.employment_details.nature_of_business;
    //     new_property = 'Nature of Business';
    //   }
    // }else{
    //   if(property == 'secondary_email'){
    //     this.old_val = (this.secondary_details.secondary_email == undefined) ? '' : this.secondary_details.secondary_email;
    //     new_property = 'Email';
    //     this.checkAddiContact.push({'status': 0});
    //     this.checkAddiContact[index].status = 0;
    //     this.checkAddiContactStatus = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkAddiContact[index].status = 0;
    //         }else{
    //           this.checkAddiContact[index].status = 1;
    //           this.checkAddiContactStatus = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }

    // }



    // if(this.new_val != this.old_val){
    //   //this.change_log_string += property+'='+this.old_val+':'+this.new_val+';';
    //   this.change_log_string.push({'property' : new_property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    // }
  }
  collectLogData(event, type, index) {
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if (type == 'address_type') {
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if (type == 'street_type') {
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if (type == 'state') {
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if (type == 'country') {
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if (type == 'housing_situation') {
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if (type == 'move_in_date') {
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if (type == 'date_of_birth') {
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
    console.log('this.change_log_string', this.change_log_string)
  }

  changeLogData(event, type, index) {
    if (event == undefined) {
      return false;
    }
    this.new_val = event;
    this.old_val = '';
    var property = '';
    if (type == 'current_marital_status') {
      this.old_val = (this.applicant_details.current_marital_status == undefined) ? '' : this.applicant_details.current_marital_status;
      property = 'Current Marital Status';
    }
    if (type == 'gender') {
      this.old_val = (this.applicant_details.gender == undefined) ? '' : this.applicant_details.gender;
      property = 'Gender';
    }

    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  public changeAddressFormat($event, index, types) {
    let streetNumber = this.primaryForm.get('street_number');
    let streetName = this.primaryForm.get('street_name');
    let streetType = this.primaryForm.get('street_type');
    if (types == 'primary_address') {
      this.address_format = $event;
      streetNumber = this.primaryForm.get('street_number');
      streetName = this.primaryForm.get('street_name');
      streetType = this.primaryForm.get('street_type');
    } else if (types == 'primary_previous') {
      streetNumber = this.primaryForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_number');
      streetName = this.primaryForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_name');
      streetType = this.primaryForm.controls.addPreviousAddressItem['controls'][index].get('previous_street_type');
    } else if (types == 'secondary_address') {
      streetNumber = this.primaryForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_number');
      streetName = this.primaryForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_name');
      streetType = this.primaryForm.controls.addAddressRelationshipItem['controls'][index].get('addi_street_type');
    }
    if ($event == 'nonStandard') {
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    } else if ($event == 'poBox') {
      streetNumber.setValidators(null);
      streetName.setValidators(null);
      streetType.setValidators(null);
    } else {
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }
    streetNumber.updateValueAndValidity();
    streetName.updateValueAndValidity();
    streetType.updateValueAndValidity();
    //this.signupSlider.resize();
    //this.signupSlider.update();

    this.new_val = event;
    this.old_val = '';
    var property = '';

  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getValue() {

    if (!this.primaryForm.valid) {

      this.primaryForm.get('firstname').markAsDirty();
      this.primaryForm.get('firstname').markAsTouched();

      this.primaryForm.get('lastname').markAsDirty();
      this.primaryForm.get('lastname').markAsTouched();

      this.primaryForm.get('email').markAsDirty();
      this.primaryForm.get('email').markAsTouched();

      this.primaryForm.get('mobile_phone').markAsDirty();
      this.primaryForm.get('mobile_phone').markAsTouched();

      this.primaryForm.get('date_of_birth').markAsDirty();
      this.primaryForm.get('date_of_birth').markAsTouched();

      this.primaryForm.get('reference_broker').markAsDirty();
      this.primaryForm.get('reference_broker').markAsTouched();

      var invalid = true;
      this.valueChange.emit(invalid);

    } else {
      this.valueChange.emit(this.primaryForm.value);
    }
  }

  getValueSecond(name) {
    console.log('name', name)
    if (!this.primaryForm.valid) {

      this.primaryForm.get('firstname').markAsDirty();
      this.primaryForm.get('firstname').markAsTouched();

      this.primaryForm.get('lastname').markAsDirty();
      this.primaryForm.get('lastname').markAsTouched();

      this.primaryForm.get('email').markAsDirty();
      this.primaryForm.get('email').markAsTouched();

      this.primaryForm.get('mobile_phone').markAsDirty();
      this.primaryForm.get('mobile_phone').markAsTouched();

      this.primaryForm.get('date_of_birth').markAsDirty();
      this.primaryForm.get('date_of_birth').markAsTouched();

      this.primaryForm.get('reference_broker').markAsDirty();
      this.primaryForm.get('reference_broker').markAsTouched();

      var invalid = true;
      this.valueChangeSecond.emit(invalid);

    } else {
      this.valueChangeSecond.emit(this.primaryForm.value);
    }
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  setFormatNumber(event, index) {
    var mobile_phone = '';
    if (index >= 0) {
      mobile_phone = this.primaryForm.controls['addAnotherApplicantItem'].value[index].secondary_mobile_phone
      mobile_phone = mobile_phone.split(" ").join("");
      let firstFour = mobile_phone.slice(0, 4);
      let number = mobile_phone.slice(4, 10);
      number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
      this.formApplicant.controls[index]['controls'].secondary_mobile_phone.setValue(number.trim());
    } else {
      mobile_phone = this.primaryForm.controls.mobile_phone.value;
      mobile_phone = mobile_phone.split(" ").join("");
      let firstFour = mobile_phone.slice(0, 4);
      let number = mobile_phone.slice(4, 10);
      number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
      this.primaryForm.controls.mobile_phone.setValue(number.trim());
    }
  }
  onPaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.split(" ").join("");
    let firstFour = pastedText.slice(0, 4);
    let number = pastedText.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.primaryForm.controls.mobile_phone.setValue('');
    this.primaryForm.controls.mobile_phone.setValue(number.trim());
  }







}




// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/component/primary-applicant/primary-form/primary.ts